import { getFirestore, collection, query, orderBy, limit, getDocs, doc, updateDoc, serverTimestamp, getDoc, where } from "firebase/firestore";
import { app } from "../firebase-config.js";

const db = getFirestore(app);
const COLLECTION_NAME = 'support_tickets';

export const AdminSupportService = {
    /**
     * Get all tickets (Paginated via limit for now)
     * @returns {Promise<Array>}
     */
    getAllTickets: async (limitCount = 100) => {
        try {
            // Need index for createdAt desc
            const q = query(
                collection(db, COLLECTION_NAME),
                orderBy("createdAt", "desc"),
                limit(limitCount)
            );
            const snapshot = await getDocs(q);
            return snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                createdAt: doc.data().createdAt?.toDate() || new Date(),
                replyAt: doc.data().replyAt?.toDate() || null
            }));
        } catch (e) {
            console.error("AdminSupportService Error:", e);
            throw e;
        }
    },

    /**
     * Send a reply to a ticket
     * @param {string} ticketId 
     * @param {string} replyContent 
     */
    replyToTicket: async (ticketId, replyContent) => {
        const ticketRef = doc(db, COLLECTION_NAME, ticketId);

        // Fetch to get userId for notification
        const ticketSnap = await getDoc(ticketRef);
        const ticketData = ticketSnap.exists() ? ticketSnap.data() : null;

        await updateDoc(ticketRef, {
            replyContent: replyContent,
            replyAt: serverTimestamp(),
            status: 'replied',
            isReadByUser: false
        });

        // Notify
        if (ticketData && ticketData.userId) {
            import("./notification-trigger.service.js").then(({ NotificationTriggerService }) => {
                NotificationTriggerService.notifySupportReply(ticketData.userId, ticketData.content);
            });
        }
    }
};
